module.exports = __webpack_public_path__ + "img/2-text.d97fda52.png";